import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';
import { IStatement } from 'services/statements/types';

enum SORT_COLUMNS {
  tableCode,
  date,
  currency,
  rate,
}

interface TableNode {
  id: string;
  currencyCode: string;
  rate: number;
  exchangeRateDate: string;
  tableCode: string;
}

const ExchangeRates = () => {
  const { values } = useFormikContext<IStatement>();
  const { t } = useTranslation();

  const columnsVisibility = useTableColumnsVisibility(
    'AdminExchangeRates1',
    SORT_COLUMNS
  );

  const tableData: TableNode[] = (values?.exchangeRates ?? []).map(rate => ({
    id: String(rate.currencyId),
    currencyCode: rate.currency.currencyCode,
    rate: rate.rate,
    exchangeRateDate: rate.exchangeRateDate,
    tableCode: rate.tableCode,
  }));

  return (
    <Table
      id={columnsVisibility.tableId}
      data={{ nodes: tableData }}
      columns={[
        {
          label: t('input.label.tableCode'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Text text={item.tableCode} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.tableCode),
        },
        {
          label: t('input.label.date'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Text
                text={
                  item.exchangeRateDate
                    ? new Date(item.exchangeRateDate).toLocaleDateString()
                    : ''
                }
              />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.date),
        },
        {
          label: t('input.label.currency'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Text text={item.currencyCode} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.currency),
        },
        {
          label: t('input.label.rate'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Text text={item.rate.toFixed(4)} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.rate),
        },
      ]}
      displayMode
    />
  );
};

export default ExchangeRates;
